import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useProductDetailContext } from '../../../../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { pushQuantitySelectionEvent } from '../../../../../../../utils/DataLayer/subscription.js';
import { SelectQuantityContainer } from '../../../../../components/SelectQuantity/SelectQuantityContainer.js';

const CLQuantitySelector = /*#__PURE__*/ React.memo(({ eyeSideId , className , isEnabled  })=>{
    const { activeVariant  } = useProductDetailContext();
    const { actions , state , triggerToastMessage  } = useCLEcommContext();
    const { quantitySelector  } = state.configurator[eyeSideId];
    const { maxSelectableQuantity , selectionInvalidatedCount  } = quantitySelector;
    const { lensesPerBox , purchaseType  } = state.configurations;
    const { quantity: selectedQuantity  } = state.configurations[eyeSideId];
    const isAvailableForSubscription = CommerceToolsApi.isLenses(activeVariant) && !!activeVariant.isAvailableForSubscription;
    React.useEffect(()=>{
        /**
     * This toast notifies the user when we have automatically adjusted the selected quantity
     * This can happen when the user has selected a quantity that is no longer available
     */ if (!!selectionInvalidatedCount) {
            triggerToastMessage('quantity-invalidated-warning');
        }
    }, [
        selectionInvalidatedCount
    ]);
    const handleQuantityChange = React.useCallback((quantity)=>{
        actions.updateSelectedQuantity(eyeSideId, quantity);
        pushQuantitySelectionEvent({
            quantity,
            purchaseType,
            isAvailableForSubscription,
            eyeSide: eyeSideId
        });
    }, []);
    return /*#__PURE__*/ React.createElement(SelectQuantityContainer, {
        className: className,
        parentId: eyeSideId,
        showLabel: true,
        onChange: handleQuantityChange,
        selectedQuantity: selectedQuantity,
        maxSelectableQuantity: maxSelectableQuantity,
        lensesPerBox: lensesPerBox,
        isDisabled: !isEnabled || !maxSelectableQuantity
    });
});

export { CLQuantitySelector };
//# sourceMappingURL=CLQuantitySelector.js.map
